var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.account1 && _vm.needConnect
        ? [
            _c(
              "el-button",
              {
                staticClass: "common-btn-blue",
                attrs: { loading: _vm.loading },
                on: { click: _vm.connectWallet },
              },
              [_vm._v("\n      Connect Wallet\n    ")]
            ),
          ]
        : [
            _c(
              "el-button",
              {
                staticClass: "common-btn-blue",
                attrs: { loading: _vm.loading, disabled: _vm.disabled },
                on: { click: _vm.clickHandle },
              },
              [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }